import React from 'react';
import { Link } from 'react-router-dom';
import { Phone, Mail, MapPin, Facebook, Instagram, Linkedin, Heart } from 'lucide-react';
export function Footer() {
  return <footer className="bg-primary text-white pt-20 pb-10 px-6" data-id="element-20">
      <div className="max-w-7xl mx-auto grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-12 mb-16" data-id="element-21">
        {/* Brand Column */}
        <div className="space-y-6" data-id="element-22">
          <img src="https://cdn.magicpatterns.com/uploads/dzDMGWvL3pUw23BZ1V2GnL/birds_nest_rev-logo.png" alt="Birds Nest Logo" className="h-16 w-auto" data-id="element-23" />
          <p className="text-white/70 leading-relaxed" data-id="element-24">
            Providing supportive independent living opportunities for adults
            throughout Maryland in a comfortable, community-focused environment.
          </p>
          <div className="flex space-x-4" data-id="element-25">
            <a href="#" className="w-10 h-10 rounded-full bg-white/10 flex items-center justify-center hover:bg-accent transition-colors" data-id="element-26">
              <Facebook size={18} data-id="element-27" />
            </a>
            <a href="#" className="w-10 h-10 rounded-full bg-white/10 flex items-center justify-center hover:bg-accent transition-colors" data-id="element-28">
              <Instagram size={18} data-id="element-29" />
            </a>
            <a href="#" className="w-10 h-10 rounded-full bg-white/10 flex items-center justify-center hover:bg-accent transition-colors" data-id="element-30">
              <Linkedin size={18} data-id="element-31" />
            </a>
          </div>
        </div>

        {/* Quick Links */}
        <div data-id="element-32">
          <h4 className="text-lg font-bold mb-6 text-accent" data-id="element-33">Quick Links</h4>
          <ul className="space-y-4 text-white/70" data-id="element-34">
            <li data-id="element-35">
              <Link to="/" className="hover:text-white transition-colors" data-id="element-36">
                Home
              </Link>
            </li>
            <li data-id="element-37">
              <Link to="/about" className="hover:text-white transition-colors" data-id="element-38">
                About Us
              </Link>
            </li>
            <li data-id="element-39">
              <Link to="/services" className="hover:text-white transition-colors" data-id="element-40">
                Our Services
              </Link>
            </li>
            <li data-id="element-41">
              <Link to="/homes" className="hover:text-white transition-colors" data-id="element-42">
                Available Homes
              </Link>
            </li>
            <li data-id="element-43">
              <Link to="/referrals" className="hover:text-white transition-colors" data-id="element-44">
                Referral Partners
              </Link>
            </li>
          </ul>
        </div>

        {/* Services */}
        <div data-id="element-45">
          <h4 className="text-lg font-bold mb-6 text-accent" data-id="element-46">Services</h4>
          <ul className="space-y-4 text-white/70" data-id="element-47">
            <li data-id="element-48">Independent Living</li>
            <li data-id="element-49">Safe Community Housing</li>
            <li data-id="element-50">Housing Placement</li>
            <li data-id="element-51">Community Resources</li>
            <li data-id="element-52">24/7 Support Access</li>
          </ul>
        </div>

        {/* Contact Info */}
        <div className="space-y-6" data-id="element-53">
          <h4 className="text-lg font-bold mb-6 text-accent" data-id="element-54">Contact Us</h4>
          <div className="space-y-4 text-white/70" data-id="element-55">
            <div className="flex items-start space-x-3" data-id="element-56">
              <MapPin size={20} className="text-accent shrink-0 mt-1" data-id="element-57" />
              <span data-id="element-58">
                Serving all of Maryland with locations in Baltimore, Silver
                Spring, and more.
              </span>
            </div>
            <div className="flex items-center space-x-3" data-id="element-59">
              <Phone size={20} className="text-accent shrink-0" data-id="element-60" />
              <span data-id="element-61">(410) 555-0123</span>
            </div>
            <div className="flex items-center space-x-3" data-id="element-62">
              <Mail size={20} className="text-accent shrink-0" data-id="element-63" />
              <span data-id="element-64">info@birdsnestliving.com</span>
            </div>
          </div>
        </div>
      </div>

      <div className="max-w-7xl mx-auto pt-8 border-t border-white/10 flex flex-col md:flex-row justify-between items-center text-sm text-white/50" data-id="element-65">
        <div className="mb-4 md:mb-0" data-id="element-66">
          © {new Date().getFullYear()} Birds Nest Independent Living LLC. All
          Rights Reserved.
        </div>
        <div className="flex space-x-6 items-center" data-id="element-67">
          <Link to="/privacy" className="hover:text-white transition-colors" data-id="element-68">
            Privacy Policy
          </Link>
          <span className="flex items-center" data-id="element-69">
            Made with{' '}
            <Heart size={12} className="mx-1 text-accent fill-accent" data-id="element-70" /> for
            Maryland
          </span>
          <div className="flex items-center space-x-2" data-id="element-71">
            <span className="text-[10px] uppercase tracking-widest font-bold border border-white/20 px-2 py-1 rounded" data-id="element-72">
              Equal Housing
            </span>
          </div>
        </div>
      </div>
    </footer>;
}